import { Link, useNavigate } from "react-router-dom";
import styles from "./SignIn.module.css";
import { useContext } from "react";
import { AuthContext } from "../../shared/Contexts/Auth/AuthContext";
import api from "../../api/api";

import { useFormik } from "formik";
import * as Yup from "yup";

const SignIn = () => {
  const { setIsLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Dirección de correo electrónico no válida")
        .required("Campo obligatorio"),
      password: Yup.string()
        .min(8, "La contraseña debe tener al menos 8 caracteres")
        .required("Campo obligatorio"),
    }),
    onSubmit: async (values) => {
      try {
        await api.register(values);
        await api.login(values);
        setIsLoggedIn(true);
        navigate("/");
      } catch (error) {
        alert("Error al iniciar sesión");
        console.log(error);
      }
    },
  });

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={formik.handleSubmit}>
        <input
          className={styles.input}
          placeholder="Enter your email"
          type="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.email && formik.errors.email && (
          <div className={styles.textWarning}>{formik.errors.email}</div>
        )}

        <input
          className={styles.input}
          placeholder="Enter your password"
          name="password"
          type="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.password && formik.errors.password && (
          <div className={styles.textWarning}>{formik.errors.password}</div>
        )}

        <button className={styles.confirmButton} type="submit">
          Sign In
        </button>

        <Link to={"/login"} className={styles.redirectLink}>
          Already have an account?{" "}
          <span className={styles.highlightedText}>Log In</span>
        </Link>
      </form>
    </div>
  );
};

export default SignIn;
